module.exports = __webpack_public_path__ + "img/320455_720DBE_560496_47047B-256px.857d6d78.png";